import { useEffect, useRef } from 'react';

const useIsMounted = () => {
  const isMountRef = useRef(true);

  useEffect(() => {
    if (isMountRef.current) {
      isMountRef.current = false;
    }
  }, []);

  return isMountRef.current;
};

export default useIsMounted;
